import { Component, Input } from '@angular/core';
import { PromptScheduleModel } from '../../../core/api/models';
import { SupervisorApiService } from '../../../core/api/services';
import { SettingsHelperService } from '../../settings.helper.service';
import { AlertService } from '../../../shared/services/alert.service';
import { Utils } from '../../../core/utils';

@Component({
  selector: 'app-prompt-schedule',
  templateUrl: './prompt-schedule.component.html',
  standalone: false,
})
export class PromptScheduleComponent {
  @Input() patientID: number = 0;
  @Input() promptSchedule: PromptScheduleModel | undefined;

  constructor(
    private supervisorApiService: SupervisorApiService,
    private settingsHelperService: SettingsHelperService,
    private alertService: AlertService
  ) {}

  isCollapsed = true;

  toggleCollapsed() {
    this.isCollapsed = !this.isCollapsed;
  }

  editPromptSchedule() {
    console.log('editPromptSchedule clicked!');
    this.settingsHelperService.addPromptScheduleButtonClicked(
      this.promptSchedule ?? null
    );
  }

  restorePromptSchedule() {
    if (this.promptSchedule?.ID != null) {
      this.supervisorApiService
        .RestorePromptSchedule({
          promptScheduleID: this.promptSchedule.ID,
        })
      .subscribe(() => {
        this.alertService.success('Prompt Schedule restored');
        this.settingsHelperService.onCloseAddPromptSchedule();
      });
    }
  }

  deletePromptSchedule() {
    console.log('deletePromptSchedule clicked!');

    this.alertService
      .confirm(
        'Delete Prompt Schedule',
        'Are you sure you want to delete this prompt schedule?'
      )
      .subscribe((result) => {
        if (result) {
          this.deletePromptCodeConfirmed();
        }
      });
  }

  deletePromptCodeConfirmed() {
    if (this.promptSchedule?.ID != null) {
      this.supervisorApiService
        .MarkPromptScheduleAsDeleted({
          promptScheduleID: this.promptSchedule.ID,
        })
        .subscribe(
          () => {
            this.alertService.success('Prompt schedule marked as deleted');
            this.settingsHelperService.onCloseAddPromptSchedule();
          },
          (error) => {
            this.alertService.error(
              Utils.getErrorMessageFromErrorResponse(error)
            );
          }
        );
    }
  }
}
